import React from 'react';

import { ICloseButton } from './interface';

import closeBtn from 'img/close-btn.svg';

import './styles.scss';

const CloseButton: React.FC<ICloseButton> = (props) => (
  <button className="close-button" {...props}>
    <img src={closeBtn} alt="" />
  </button>
);

export default CloseButton;
